var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-ons-page",
    [
      _c("v-ons-toolbar", { attrs: { inline: "true" } }, [
        _c(
          "div",
          { staticClass: "left" },
          [_c("v-ons-toggle-sidebar-button")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "center" }, [_vm._v("Управление")])
      ]),
      _vm._v(" "),
      _c(
        "ons-list",
        [
          _c(
            "ons-list-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.storages.length > 1,
                  expression: "storages.length > 1"
                }
              ],
              attrs: { modifier: "chevron longdivider" },
              on: { click: _vm.showChooseStorage }
            },
            [
              _c("span", { staticClass: "list-item__title" }, [
                _vm._v("Склад: " + _vm._s(_vm.selectedStorageName))
              ]),
              _vm._v(" "),
              _vm.selectedStorage && !_vm.selectedStorage.is_configured
                ? _c(
                    "span",
                    {
                      staticClass: "list-item__subtitle",
                      staticStyle: { color: "red" }
                    },
                    [_vm._v("\n                Не настроено\n            ")]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "ons-list-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.$user.isAdmin ||
                    _vm.$user.hasPermission("canManageCatalog"),
                  expression:
                    "$user.isAdmin || $user.hasPermission('canManageCatalog')"
                }
              ],
              attrs: { modifier: "chevron longdivider", tappable: "" },
              on: {
                click: function($event) {
                  return _vm.$router.push(
                    _vm.currentRoute + "/catalog-settings"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "center" }, [
                _vm._v("Настройка каталога")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ons-list-item",
            {
              attrs: { modifier: "chevron longdivider", tappable: "" },
              on: {
                click: function($event) {
                  return _vm.$router.push(
                    _vm.currentRoute + "/shipping-payment-methods"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "center" }, [
                _vm._v("Типы цен, скидки, способы отгрузки")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ons-list-item",
            {
              attrs: { modifier: "chevron longdivider", tappable: "" },
              on: {
                click: function($event) {
                  return _vm.$router.push(
                    _vm.currentRoute + "/shipping-by-routes"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "center" }, [
                _vm._v("График приемки заказов и доставки по маршрутам")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ons-list-item",
            {
              attrs: { modifier: "chevron longdivider", tappable: "" },
              on: {
                click: function($event) {
                  return _vm.$router.push(
                    _vm.currentRoute + "/pickup-shipment-schedule"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "center" }, [
                _vm._v("График отгрузки самовывоза")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "ons-list-item",
            {
              attrs: { modifier: "chevron longdivider", tappable: "" },
              on: {
                click: function($event) {
                  return _vm.$router.push(
                    _vm.currentRoute + "/special-schedules"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "center" }, [
                _vm._v("Специальный график работы")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-list-dialog", {
        ref: "chooseStorageDialog",
        attrs: { title: "Выберите склад", items: _vm.storages }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5729e402", { render: render, staticRenderFns: staticRenderFns })
  }
}